import { render, staticRenderFns } from "./PayItemTypeEdit.vue?vue&type=template&id=28a4cdeb"
import script from "./PayItemTypeEdit.vue?vue&type=script&lang=js"
export * from "./PayItemTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports